<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Webchat" class="d-icon d-icon--webchat" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.667a.167.167 0 0 0-.167-.167H2.167A.167.167 0 0 0 2 5.667v4.126l.26-.26a1.25 1.25 0 0 1 .884-.366h3.689A.168.168 0 0 0 7 9V5.667Zm1 1h.856c.332 0 .65.132.884.366l.26.26V3.167A.167.167 0 0 0 9.833 3H5.167A.167.167 0 0 0 5 3.167V4.5h1.833A1.167 1.167 0 0 1 8 5.667v1Zm3 1.23a.75.75 0 0 1-1.28.53l-.687-.687a.251.251 0 0 0-.177-.073H8V9a1.167 1.167 0 0 1-1.167 1.167h-3.69a.251.251 0 0 0-.176.073l-.687.687a.75.75 0 0 1-1.28-.53v-4.73A1.167 1.167 0 0 1 2.167 4.5H4V3.167A1.167 1.167 0 0 1 5.167 2h4.666A1.167 1.167 0 0 1 11 3.167v4.73Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconWebchat',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
